import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
import { PaymentInputsContainer, PaymentInputsWrapper } from 'react-payment-inputs';
import images from 'react-payment-inputs/images';
import Button from 'reactstrap/lib/Button';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import { Field, useFormikContext } from 'formik';

import Card from 'Lib/components/common/Card';
import Currency from 'Lib/components/common/Currency';
import TextField from 'Lib/components/form/TextField';
import ProcessingFeeTypes from 'Lib/constants/accounting/payments/processingFeeTypes';

const Submit = ({ paymentInformation, paymentMessage, setSubmit }) => {
	const isSubmitDisabled = meta => {
		const { values } = useFormikContext();

		const hasRequiredFields = values.nameOnCard && values.cardNumber && values.expiryDate && values.cvc;

		const hasValidationErrors = meta && meta.erroredInputs && Object.keys(meta.erroredInputs).some(key => meta.erroredInputs[key]);

		return !hasRequiredFields || hasValidationErrors;
	};

	return (
		<Card title="Pay & Submit">
			<FroalaEditorView model={paymentMessage} />
			<br />
			<Row>
				<Col style={{ padding: '0' }}>
					<div style={{ borderRadius: '8px', padding: '20px', border: '2px solid #e6e6e6' }}>
						<h4>Application Fee</h4>
						<br />
						Application Fee: <Currency value={paymentInformation?.applicationFeeAmount || 0} />
						{paymentInformation?.processingFeeTypeID == ProcessingFeeTypes.Tenant && (
							<div>
								<br />
								Processing Fee: <Currency value={paymentInformation?.processingFeeAmount} />
								<hr />
								Total Due: <Currency value={paymentInformation?.totalPaymentAmount} />
							</div>
						)}
						<br />
						<br />
						By clicking the &apos;Submit and Pay&apos; button you understand that:
						<ul>
							<li>A one time charge will appear on your statement as Rentvine</li>
							<li>I understand that the application is not submitted until payment has been completed</li>
							<li>The processing fee is non-refundable</li>
						</ul>
					</div>
				</Col>
				<Col style={{ padding: '0', paddingBottom: '10px' }}>
					<div style={{ height: '90%', padding: '10px', width: '100%' }}>
						<div>
							<TextField id="nameOnCard" name="nameOnCard" label="Name On Card" isRequired />
							<PaymentInputsContainer>
								{({ getCardNumberProps, getExpiryDateProps, getCVCProps, getCardImageProps, wrapperProps, meta }) => (
									<>
										<div className="creditCardContainer" style={{ display: 'flex', justifyContent: 'center' }}>
											<PaymentInputsWrapper
												{...wrapperProps}
												styles={{
													fieldWrapper: {
														base: `margin-top: 1rem;`
													},
													input: {
														cardNumber: `max-width: 10rem;`,
														expiryDate: `max-width: 5rem;`,
														cvc: `max-width: 5rem;`
													},
													width: '100%'
												}}>
												<svg {...getCardImageProps({ images })} />
												<Field id="cardNumber" name="cardNumber">
													{({ field }) => <input value={field.value} {...getCardNumberProps({ onBlur: field.onBlur, onChange: field.onChange })} />}
												</Field>
												<Field id="expiryDate" name="expiryDate">
													{({ field }) => <input value={field.value} {...getExpiryDateProps({ onBlur: field.onBlur, onChange: field.onChange })} />}
												</Field>
												<Field id="cvc" name="cvc">
													{({ field }) => <input value={field.value} {...getCVCProps({ onBlur: field.onBlur, onChange: field.onChange })} />}
												</Field>
											</PaymentInputsWrapper>
										</div>
										<div style={{ padding: '10px', position: 'absolute', bottom: '0', right: '0' }}>
											<Button color="primary" onClick={() => setSubmit(true)} disabled={isSubmitDisabled(meta)}>
												Submit and Pay
											</Button>
										</div>
									</>
								)}
							</PaymentInputsContainer>
						</div>
					</div>
				</Col>
			</Row>
		</Card>
	);
};

export default Submit;
